import { css } from "glamor";
import React from "react";
import {
  Button,
  Link,
  colors,
  spacing,
  styles,
} from "../../library";

import GraduationCapIcon from "../../library/images/graduation-cap-icon.svg";
import SliderIcon from "../../library/images/slider-icon.svg";
import MockCreateLinkButton from "./MockCreateLinkButton";
import MockResumeContainer from "./MockResumeContainer";

const container = css({
  textAlign: "center",
  padding: spacing.m,
});
const titleWrapper = css({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: spacing.m,
});
const titleClass = css(styles.alternativeFontFamily, {
  display: "flex",
  alignItems: "center",
  gap: spacing.s,
  fontSize: 24,
  fontWeight: "bold",
  color: colors.secondary,
  lineHeight: 1.5,
});
const buttonsWrapper = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: spacing.m,
  marginBottom: spacing.m,
});

export default function Mocks() {

  return (
    <div className={container}>
      <div className={titleWrapper}>
        <div className={titleClass}>Simulados</div>
        <Link
          component={Button}
          to="/mobile/questions"
          color="outline"
          circular={false}
          size="small"
        >
          Buscar questões
        </Link>
      </div>

      <div className={buttonsWrapper}>
        <MockCreateLinkButton
          to="/mobile/mocks/custom/new"
          image={SliderIcon}
          title="Simulado Personalizado"
          subtitle={`
            Personalize seus simulados escolhendo o módulo que deseja
            reponder, o número de questões e outras opções do questionário.
          `}
        />
        <MockCreateLinkButton
          to="/mobile/mocks/exam/new"
          image={GraduationCapIcon}
          title="Simular Prova"
          subtitle={`
            Faça a prova semelhante ao exame do curso selecionado, com o mesmo
            número de questões e os pesos por módulo da prova.
          `}
        />
      </div>

      <MockResumeContainer />

      <Link
        to="/mobile/mocks/list"
        component={Button}
        circular={false}
        color="outline"
        size="big"
        fluid
      >
        Ver todos os simulados
      </Link>
    </div>
  );
}
